import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./nav.css";

const Nav: React.FC = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(prev => !prev);
    };

    const handleLinkClick = () => {
        setMenuOpen(false);
    };

    return (
        <nav className="nav">
            <div className="nav-container">
                <div className="nav-links">
                    <NavLink
                        to="/"
                        onClick={handleLinkClick}
                        className={({ isActive }) => isActive ? "active" : ""}>
                        Hem
                    </NavLink>
                    <NavLink
                        to="/skidservice"
                        onClick={handleLinkClick}
                        className={({ isActive }) => isActive ? "active" : ""}>
                        Skidservice
                    </NavLink>
                    <NavLink
                        to="/om"
                        onClick={handleLinkClick}
                        className={({ isActive }) => isActive ? "active" : ""}>
                        Om
                    </NavLink>
                    <NavLink
                        to="/kontakt"
                        onClick={handleLinkClick}
                        className={({ isActive }) => isActive ? "active" : ""}>
                        Kontakt
                    </NavLink>
                </div>
                <div
                    className={`hamburger ${menuOpen ? "open" : ""}`}
                    onClick={toggleMenu}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            toggleMenu();
                        }
                    }}
                    role="button"
                    tabIndex={0}
                    aria-label="Toggle menu"
                >
                    <span className="bar"></span>
                    <span className="bar"></span>
                    <span className="bar"></span>
                </div>
            </div>
            {menuOpen && (
                <div className="mobile-menu">
                    <NavLink
                        to="/"
                        onClick={handleLinkClick}
                        className={({ isActive }) => isActive ? "active" : ""}>
                        Hem
                    </NavLink>
                    <NavLink
                        to="/skidservice"
                        onClick={handleLinkClick}
                        className={({ isActive }) => isActive ? "active" : ""}>
                        Skidservice
                    </NavLink>
                    <NavLink
                        to="/om"
                        onClick={handleLinkClick}
                        className={({ isActive }) => isActive ? "active" : ""}>
                        Om
                    </NavLink>
                    <NavLink
                        to="/kontakt"
                        onClick={handleLinkClick}
                        className={({ isActive }) => isActive ? "active" : ""}>
                        Kontakt
                    </NavLink>
                </div>
            )}
        </nav>
    );
};

export default Nav;
